<app-header></app-header>
<div style="min-height: 500px">
    <app-bread-crumbs [deliminator]="'/'"></app-bread-crumbs>
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>